import React from 'react';
import { Label } from './ui/label';
import { cn } from '../lib/utils';

/**
 * RequiredLabel — Label with a red asterisk suffix.
 * Use this on every form field the backend treats as required so the
 * requirement is unmistakable at glance. Pair with `data-invalid` on
 * inputs when the user tries to submit an empty required field — the
 * input's Tailwind `data-[invalid=true]:border-red-500` picks it up.
 */
export const RequiredLabel = ({ children, className, ...props }) => (
  <Label className={cn('inline-flex items-center gap-1', className)} {...props}>
    {children}
    <span className="text-red-500" aria-label="required">*</span>
  </Label>
);

export default RequiredLabel;
